module.exports = __webpack_public_path__ + "static/media/pelham-project.81019dd4.png";